module.exports = __webpack_public_path__ + "assets/images/rideCleanup-662396a7617c24bd7c863272ca1f3ee8.webm";